(function (aimi_mdcdot_user_api, $, app, undefined) {


  app.apis['mdcdot_user'] = {

    update : function (requestData) {
      return app.putRequest(`/api/mdcdot/user`, requestData, function () {
      }, function () {
      }, '');
    },

    'scoring-update' : function (requestData) {
      return app.putRequest(`/api/mdcdot/scores`, requestData, function () {
      }, function () {
      }, '');
    }
  }



}(window.aimi_mdcdot_user_api = window.aimi_mdcdot_user_api || {}, jQuery, PreBuilt));
